import { render, staticRenderFns } from "./EditPortfolio.vue?vue&type=template&id=369b5e41&scoped=true&"
import script from "./EditPortfolio.vue?vue&type=script&lang=js&"
export * from "./EditPortfolio.vue?vue&type=script&lang=js&"
import style0 from "./EditPortfolio.vue?vue&type=style&index=0&id=369b5e41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369b5e41",
  null
  
)

export default component.exports